import { render, staticRenderFns } from "./BookingTable.vue?vue&type=template&id=4473ad4a"
import script from "./BookingTable.vue?vue&type=script&lang=js"
export * from "./BookingTable.vue?vue&type=script&lang=js"
import style0 from "./BookingTable.vue?vue&type=style&index=0&id=4473ad4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports